import { injectTranslate } from '@recruitee/i18n';
import { textCellFactory } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const eeoColumn = defineOfferTableColumn(() => {
  const t = injectTranslate();
  return {
    id: OfferColumnId.Eeo,
    label: t('app.offers.table.eeo_compliance'),
    visible: false,
    geometry: {
      width: 120,
      minWidth: 120,
      maxWidth: 140,
      autoFitProp: 'width',
    },
    options: {
      draggable: false,
      resizable: true,
      removable: true,
      sortable: false,
    },
    componentFactory: textCellFactory('eeoSettings', eeoSettings =>
      eeoSettings?.enabled ? t`app.common.enabled` : null,
    ),
  };
});
